














































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Coupon, Tenant } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import dayjs from "dayjs";

const db = firebaseProject.firestore();
const coupon = new Collection(
  db.collection("coupon") as firestore.CollectionReference<Coupon>
);

const tenant = new Collection(
  db.collection("tenant") as firestore.CollectionReference<Tenant>
);

export default shopBase.extend(Vue).extend({
  name: "shopqreCouponList",
  mixins: [],
  data() {
    return {
      authentication,
      transitionName: "",
      cancelCodeLimit: "",
      cancelCodeLimitTimer: 0,
      parPage: 10,
      currentPage: 1
    };
  },
  computed: {
    tenants(): List<Tenant> {
      return tenant.query({
        filter: {
          shopId: { $eq: this.shopId }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    },
    coupons(): List<Coupon> {
      return coupon.query({
        filter: {
          shopId: { $eq: this.shopId },
          isQreCoupon: { $eq: 1 }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    },
    listItem(): DocDataRef<Coupon>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.coupons?.items
        ? this.coupons.items.slice(start, current)
        : [];
    },
    getPageCount(): number {
      return this.coupons?.items
        ? Math.ceil(this.coupons.items.length / this.parPage)
        : 0;
    },
    total(): number {
      return this.coupons.items?.length || 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    async deleteCoupon() {
      //TODO needs implementation
    },
    getTenantList(coupon: DocDataRef<Coupon>): string {
      const item = coupon.data;
      if (!item) return "";
      let shopNames = "";
      if (item?.mogiri && item?.tenantSelectedType) {
        // 店舗別上限設定がある場合
        if (item?.tenantSelectedDatas) {
          for (const tenantSelectedData of item?.tenantSelectedDatas) {
            const tenant = this.tenants?.items?.find(
              (shop: DocDataRef<Tenant>) => {
                return shop.id === tenantSelectedData?.tenantId;
              }
            );
            if (tenant) {
              if (shopNames) {
                shopNames += "、";
              }
              shopNames += tenant.data?.shopName;
            }
          }
        }
      }
      return shopNames;
    }
  },
  watch: {}
});
